module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "page-footer"
  }, [_c('div', {
    staticClass: "page-footer-inner"
  }, [_vm._v("\n      © " + _vm._s(_vm.getCurrentYear) + " CaseMGR Solutions, Inc. All Rights Reserved.\n      "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-to-top"
  }, [_c('i', {
    staticClass: "icon-arrow-up"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b3e768","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Footer.vue
// module id = 1566
// module chunks = 1